import { render } from "./DestinationAutocomplete.vue?vue&type=template&id=5b10b465"
import script from "./DestinationAutocomplete.vue?vue&type=script&lang=js"
export * from "./DestinationAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__